(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["offsider-academy-modules"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function prefersReducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function updateNavState(root) {
      const scroller = root.querySelector('[data-offsider-academy-modules-scroller]');
      const prev = root.querySelector('[data-offsider-academy-modules-prev]');
      const next = root.querySelector('[data-offsider-academy-modules-next]');
      if (!scroller) return;

      const maxScroll = scroller.scrollWidth - scroller.clientWidth;
      const atStart = scroller.scrollLeft <= 4;
      const atEnd = scroller.scrollLeft >= maxScroll - 4;

      if (prev) prev.disabled = atStart;
      if (next) next.disabled = atEnd;
    }

    function scrollByPage(root, direction) {
      const scroller = root.querySelector('[data-offsider-academy-modules-scroller]');
      if (!scroller) return;

      const card = scroller.querySelector('.offsider-academy-module-card');
      const gap = parseFloat(getComputedStyle(scroller.querySelector('.offsider-academy-modules__track')).gap) || 24;
      const amount = card ? card.offsetWidth + gap : Math.floor(scroller.clientWidth * 0.85);

      scroller.scrollBy({
        left: direction * amount,
        behavior: prefersReducedMotion() ? 'auto' : 'smooth',
      });
    }

    function initModules(root) {
      const scroller = root.querySelector('[data-offsider-academy-modules-scroller]');
      const prev = root.querySelector('[data-offsider-academy-modules-prev]');
      const next = root.querySelector('[data-offsider-academy-modules-next]');

      if (!scroller) return;

      const onScroll = () => updateNavState(root);
      scroller.addEventListener('scroll', onScroll, { passive: true });

      if (prev) {
        prev.addEventListener('click', () => scrollByPage(root, -1));
      }

      if (next) {
        next.addEventListener('click', () => scrollByPage(root, 1));
      }

      updateNavState(root);

      if (typeof ResizeObserver !== 'undefined') {
        const observer = new ResizeObserver(() => updateNavState(root));
        observer.observe(scroller);
      }
    }

    document.addEventListener('DOMContentLoaded', () => {
      document.querySelectorAll('[data-offsider-academy-modules]').forEach(initModules);
    });

    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll?.('[data-offsider-academy-modules]').forEach(initModules);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["offsider-blog-news-row"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__offsiderBlogNewsRowScroll) return;
    window.__offsiderBlogNewsRowScroll = true;
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-offsider-news-row-next]');
      if (!btn) return;
      var root = btn.closest('[data-offsider-news-row]');
      if (!root) return;
      var track = root.querySelector('[data-offsider-news-row-track]');
      if (!track) return;
      var step = Math.max(track.clientWidth * 0.72, 240);
      track.scrollBy({ left: step, behavior: 'smooth' });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["offsider-scores-strip"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function prefersReducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function scrollStrip(scroller, direction) {
      const amount = Math.max(120, Math.floor(scroller.clientWidth * 0.75));
      scroller.scrollBy({
        left: direction * amount,
        behavior: prefersReducedMotion() ? 'auto' : 'smooth',
      });
    }

    function initStrip(root) {
      const scroller = root.querySelector('[data-offsider-scores-scroller]');
      const prev = root.querySelector('[data-offsider-scores-prev]');
      const next = root.querySelector('[data-offsider-scores-next]');
      if (!scroller) return;

      prev?.addEventListener('click', () => scrollStrip(scroller, -1));
      next?.addEventListener('click', () => scrollStrip(scroller, 1));
    }

    document.addEventListener('DOMContentLoaded', () => {
      document.querySelectorAll('offsider-scores-strip').forEach(initStrip);
    });

    document.addEventListener('shopify:section:load', (event) => {
      const strip = event.target.querySelector?.('offsider-scores-strip');
      if (strip) initStrip(strip);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["offsider-social-live"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__offsiderHScrollBound) return;
    window.__offsiderHScrollBound = true;
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-offsider-hscroll-next]');
      if (!btn) return;
      var root = btn.closest('[data-offsider-hscroll]');
      if (!root) return;
      var track = root.querySelector('[data-offsider-hscroll-track]');
      if (!track) return;
      var step = Math.max(track.clientWidth * 0.72, 240);
      track.scrollBy({ left: step, behavior: 'smooth' });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["offsider-youtube-highlights"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__offsiderHScrollBound) return;
    window.__offsiderHScrollBound = true;
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-offsider-hscroll-next]');
      if (!btn) return;
      var root = btn.closest('[data-offsider-hscroll]');
      if (!root) return;
      var track = root.querySelector('[data-offsider-hscroll-track]');
      if (!track) return;
      var step = Math.max(track.clientWidth * 0.72, 240);
      track.scrollBy({ left: step, behavior: 'smooth' });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
